var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPingPong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.26 115.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m136.38,82.54c-7.44,7.98-17.61,12.18-27.42,12.17-.07,0-.14-.03-.19-.08l-30.07-28.06c-.05-.05-.09-.12-.09-.19-.68-9.78,2.81-20.22,10.25-28.2,1.25-1.34,2.58-2.58,3.98-3.72.46-.37.92-.73,1.38-1.07,13.48-10.02,32.53-11.23,44.03-.5,5.54,5.17,8.44,12.29,8.93,19.86.53,8.12-1.7,16.77-6.39,24.1-.31.49-.64.97-.97,1.45-1.04,1.47-2.19,2.89-3.44,4.23Z",
    style: {
      fill: "#e73f3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.05,39.5c1.25-1.34,2.58-2.58,3.98-3.72.46-.37.92-.73,1.38-1.07,13.48-10.02,32.53-11.23,44.03-.5,4.72,4.4,7.52,10.22,8.55,16.53-.85-6.81-3.7-13.13-8.74-17.84-11.49-10.72-30.55-9.52-44.03.5-.47.34-.93.7-1.38,1.07-1.4,1.14-2.73,2.38-3.98,3.72-7.44,7.98-10.93,18.41-10.25,28.2,0,.07.04.14.09.19l.05.05c-.37-9.47,3.12-19.44,10.3-27.13Z",
    style: {
      fill: "#fff",
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.85,94.71c-4.98-3.2-9.16-3.7-12.3-3.25-2.63.38-4.53,1.44-5.56,2.16-.58.4-.87.68-.87.68l-9.82-9.16s.27-.31.63-.91c.64-1.07,1.57-3.04,1.77-5.7.24-3.16-.56-7.29-4.09-12.04l30.24,28.21Z",
    style: {
      fill: "#7b4e29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.7,75.91l-7.77,8.32c.64-1.07,1.57-3.04,1.77-5.7l4.1-4.4,1.9,1.77Z",
    style: {
      fill: "#eeded2",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.66,87.07l-4.1,4.4c-2.63.38-4.53,1.44-5.56,2.16l7.77-8.32,1.89,1.77Z",
    style: {
      fill: "#eeded2",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.76,85.3l-27.79,29.78c-.73.78-1.93.84-2.73.15-.02-.01-.04-.03-.06-.05l-7.17-6.69s-.04-.04-.06-.06c-.75-.75-.77-1.96-.04-2.73l27.79-29.78,10.06,9.39Z",
    style: {
      fill: "#ab7448"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 58.36,
    y: 96.45,
    width: 38.49,
    height: 2.39,
    transform: "translate(-46.73 87.77) rotate(-46.98)",
    style: {
      fill: "#d09267"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.03,
    y: 98.77,
    width: 38.49,
    height: 0.87,
    transform: "translate(-47.34 89.49) rotate(-46.98)",
    style: {
      fill: "#d09267"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.5,87.09l-26.26,28.14s-.04-.03-.06-.05l-.97-.9,26.26-28.14,1.02.95Z",
    style: {
      fill: "#d09267"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.82,80.85l-26.26,28.14-.54-.51s-.04-.04-.06-.06l26.26-28.14.6.56Z",
    style: {
      fill: "#d09267"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 95.12,
    width: 38.49,
    height: 1.4,
    transform: "translate(-46.02 85.76) rotate(-46.98)",
    style: {
      fill: "#d09267"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m95.12,81.9l-27.79,29.78c-.73.78-1.93.84-2.73.15-.02-.01-.04-.03-.06-.05l3.64,3.4s.04.04.06.05c.8.69,2,.64,2.73-.15l27.79-29.78-3.64-3.4Z",
    style: {
      fill: "#eeded2",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.76,85.3c-2.67,2.86-7.08,3.08-9.86.49-2.78-2.59-2.87-7.01-.2-9.87l10.06,9.39Z",
    style: {
      fill: "#e0a478"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.45,76.62l-.75-.7c-2.67,2.86-2.58,7.28.2,9.87.13.12.26.22.39.33-2.42-2.63-2.39-6.77.16-9.5Z",
    style: {
      fill: "#fff",
      mixBlendMode: "overlay",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.38,82.54c-7.44,7.98-17.61,12.18-27.42,12.17-.07,0-.14-.03-.19-.08l-25.62-23.91c.72.5,1.45.99,2.18,1.47,5.91,3.82,12.56,6.69,19.56,7.3,10.61.93,21.15-3.47,29.55-10.02,3.9-3.05,7.48-6.61,10.05-10.85,1.12-1.84,2.04-3.82,2.7-5.87.53,8.12-1.7,16.77-6.39,24.1-.31.49-.64.97-.97,1.45-1.04,1.47-2.19,2.89-3.44,4.23Z",
    style: {
      fill: "#f7c1c3",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.27,85.95c7.83,7.6,18.19,11.29,27.99,10.8.07,0,.14-.03.19-.08l28.64-29.52c.05-.05.08-.12.08-.2.19-9.81-3.81-20.05-11.64-27.65-1.31-1.27-2.7-2.45-4.16-3.52-.47-.35-.95-.68-1.44-1-13.96-9.34-33.05-9.6-44,1.68C2.67,41.9.12,49.15,0,56.74c-.13,8.14,2.53,16.67,7.58,23.75.34.47.69.94,1.04,1.4,1.12,1.42,2.33,2.78,3.64,4.05Z",
    style: {
      fill: "#e73f3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.41,40.61c-1.31-1.27-2.7-2.45-4.16-3.52-.47-.35-.95-.68-1.44-1-13.96-9.34-33.05-9.6-44,1.68C3.32,42.41.81,48.36.09,54.71c.51-6.84,3.04-13.3,7.85-18.25,10.95-11.28,30.04-11.03,44-1.68.48.32.96.66,1.44,1,1.46,1.07,2.85,2.24,4.16,3.52,7.83,7.6,11.83,17.85,11.64,27.65,0,.07-.03.14-.08.19l-.05.05c-.1-9.48-4.08-19.26-11.63-26.59Z",
    style: {
      fill: "#fff",
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.37,96.74c4.82-3.44,8.97-4.15,12.12-3.85,2.65.25,4.6,1.22,5.66,1.88.59.37.9.64.9.64l9.35-9.64s-.28-.3-.67-.88c-.69-1.04-1.71-2.96-2.05-5.6-.39-3.15.19-7.31,3.49-12.23l-28.8,29.68Z",
    style: {
      fill: "#7b4e29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.56,76.96l8.17,7.93c-.69-1.04-1.71-2.96-2.05-5.6l-4.31-4.19-1.81,1.86Z",
    style: {
      fill: "#eeded2",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.18,88.7l4.32,4.19c2.65.25,4.6,1.22,5.66,1.88l-8.17-7.93-1.8,1.86Z",
    style: {
      fill: "#eeded2",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.98,86.84l29.23,28.37c.77.74,1.97.74,2.73.01.02-.01.04-.03.06-.05l6.83-7.04s.04-.04.05-.06c.71-.78.67-1.99-.09-2.73l-29.23-28.37-9.58,9.88Z",
    style: {
      fill: "#ab7448"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.53,
    y: 78.87,
    width: 2.39,
    height: 38.49,
    transform: "translate(-48.64 81.27) rotate(-45.86)",
    style: {
      fill: "#d09267"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.7,
    y: 80.52,
    width: 0.87,
    height: 38.49,
    transform: "translate(-50.3 80.63) rotate(-45.86)",
    style: {
      fill: "#d09267"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.33,88.41l27.62,26.8s.04-.03.06-.05l.92-.95-27.63-26.8-.97,1Z",
    style: {
      fill: "#d09267"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.69,81.85l27.63,26.8.52-.53s.04-.04.05-.06l-27.62-26.8-.57.59Z",
    style: {
      fill: "#d09267"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.89,
    y: 76.96,
    width: 1.4,
    height: 38.49,
    transform: "translate(-46.7 82.02) rotate(-45.86)",
    style: {
      fill: "#d09267"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m53.45,83.26l29.23,28.37c.77.74,1.97.74,2.73.01.02-.01.04-.03.06-.05l-3.47,3.58s-.04.04-.06.05c-.76.73-1.97.73-2.73-.01l-29.23-28.37,3.47-3.58Z",
    style: {
      fill: "#eeded2",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.98,86.84c2.81,2.72,7.23,2.72,9.87,0,2.65-2.73,2.52-7.15-.29-9.87l-9.58,9.88Z",
    style: {
      fill: "#e0a478"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.85,77.7l.72-.74c2.81,2.72,2.94,7.14.29,9.87-.12.12-.25.24-.38.35,2.28-2.74,2.05-6.88-.63-9.48Z",
    style: {
      fill: "#fff",
      mixBlendMode: "overlay",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.27,85.95c7.83,7.6,18.19,11.29,27.99,10.8.07,0,.14-.03.19-.08l24.4-25.15c-.69.54-1.4,1.07-2.11,1.58-5.71,4.1-12.21,7.3-19.18,8.26-10.55,1.45-21.3-2.41-30.01-8.54-4.05-2.85-7.8-6.23-10.57-10.33-1.21-1.78-2.23-3.71-2.99-5.73-.13,8.14,2.53,16.67,7.58,23.75.34.47.69.94,1.04,1.4,1.12,1.42,2.33,2.78,3.64,4.05Z",
    style: {
      fill: "#f7c1c3",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.73,
    cy: 15.25,
    rx: 15.02,
    ry: 15.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.13,2.61c.96,2.08,1.47,4.41,1.41,6.86-.22,8.42-7.12,15.07-15.41,14.84-2.97-.08-5.72-1.03-8.01-2.61,2.34,5.06,7.33,8.62,13.21,8.78,8.29.22,15.19-6.43,15.41-14.84.14-5.4-2.51-10.22-6.61-13.04Z",
    style: {
      fill: "#ebebeb",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.08,13.4c-1.88,2.81-5.17,3.88-7.36,2.37-2.19-1.5-2.44-5.01-.56-7.82,1.88-2.81,5.17-3.88,7.36-2.37,2.19,1.5,2.44,5.01.56,7.82Z",
    style: {
      fill: "#fff"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPingPong);
export default __webpack_public_path__ + "static/media/ping-pong.f88b4fe89458f913fd5fd8bd04261333.svg";
export { ForwardRef as ReactComponent };